export default "/fonts/vendor/tinymce/skins/lightgray/tinymce.ttf?a55bdbe26000fc2ca28e876d4483f4d6";